// @ts-nocheck
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import OrderActions, { OrderActionsPresentationProps } from "@store/Library/Components/Toolkit/Order/OrderActions";
import OrderStickyAction, { OrderStickyActionProps } from "@store/Library/Components/Toolkit/Order/OrderStickyAction";
import constants from "@store/constants";
import { useInvoicePaymentContext } from "@store/Framework/Components/InvoicePaymentContext/InvoicePaymentContext";
import { useLocation } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import React, { FC } from "react";

export interface InvoicePaymentActionsProps {
    styles?: ButtonPresentationProps;
}

export interface InvoicePaymentActionsStyles {
    orderActions?: OrderActionsPresentationProps;
    orderStickyAction?: OrderStickyActionProps;
    submitButton?: ButtonPresentationProps;
}

export const invoicePaymentActionsStyles: InvoicePaymentActionsStyles = {};

const styles = invoicePaymentActionsStyles;

const InvoicePaymentActions: FC<InvoicePaymentActionsProps> = () => {
    const { paymentSuccess } = useInvoicePaymentContext();
    const { search } = useLocation();
    const { sessionId, redirectResult } = parseQueryString<{ sessionId?: string; redirectResult?: string }>(search);

    if (paymentSuccess) {
        return null;
    }

    const onClickSubmit = () => {
        document.getElementById("invoicePaymentForm-submit")?.click();
    };

    return (
        <OrderActions {...styles.orderActions}>
            <OrderStickyAction {...styles.orderStickyAction}>
                <Button
                    {...styles.submitButton}
                    disabled={!!sessionId && !!redirectResult}
                    onClick={onClickSubmit}
                    type="submit"
                >
                    {translate("grimco_invoiceHistory_submitPayment")}
                </Button>
            </OrderStickyAction>
        </OrderActions>
    );
};

const widgetModule: WidgetModule = {
    component: InvoicePaymentActions,
    definition: {
        group: constants.widgetGroup.invoicePayment,
        displayName: "Actions",
        allowedContexts: [constants.pageType.invoicePayment],
    },
};

export default widgetModule;
